/**
 * Route table shared by the router, the navbars and the scroll-end
 * "next page" transition (home → card → home; about → home).
 *
 * `/about` is still served but is no longer linked from the navbar or the
 * mobile drawer — only from the footer, as in the current hand-off.
 */
export const ROUTES = {
  home: {
    path: '/',
    name: 'Home',
    /* Same string as <title> in public/index.html: RouteChrome re-applies it
       on mount, so the two must match for the SEO title to survive. */
    title: 'GoSats - Transforming Spends into Valuable Assets | Trusted by 1M+ Users',
    load: () => import('./pages/home/HomePage'),
  },
  card: {
    path: '/card',
    name: 'The Card',
    title: 'The GoSats Card',
    load: () => import('./pages/card/CardPage'),
  },
  about: {
    path: '/about',
    name: 'About Us',
    title: 'About, GoSats',
    load: () => import('./pages/about/AboutPage'),
  },
};

export const NEXT_PAGE = {
  home: ROUTES.card,
  card: ROUTES.home,
  about: ROUTES.home,
};

/* External job board. Spread CAREERS_LINK_PROPS onto every Careers <a> so
   it always opens in a new tab with the same rel hardening. */
export const CAREERS_HREF = 'https://www.workatastartup.com/companies/gosats';
export const CAREERS_LINK_PROPS = {
  href: CAREERS_HREF,
  target: '_blank',
  rel: 'noopener noreferrer',
};

/* App download behind every "Get the GoSats Card" CTA: the smart link carried
   over from the previous site (Href.GOSATS_ONELINK in src/Constants/hrefLinks.js),
   which routes to the App Store / Play Store by device. Spread
   DOWNLOAD_LINK_PROPS onto the <a> so it opens in a new tab, as every other
   external link here does. */
export const DOWNLOAD_HREF = 'https://dl.gosats.io/nHiknZH';
export const DOWNLOAD_LINK_PROPS = {
  href: DOWNLOAD_HREF,
  target: '_blank',
  rel: 'noopener noreferrer',
};

/* Support mailbox behind every "Contact support" CTA. */
export const SUPPORT_EMAIL = 'support@gosats.io';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

/* Footer "Follow" links; all external, opened in a new tab. */
export const SOCIAL_LINKS = [
  { label: 'X / Twitter', text: 'X/Twitter', href: 'https://x.com/gosatsapp', icon: 'x' },
  { label: 'Instagram', text: 'Instagram', href: 'https://www.instagram.com/gosatsapp', icon: 'instagram' },
  { label: 'LinkedIn', text: 'LinkedIn', href: 'https://www.linkedin.com/company/gosats/', icon: 'linkedin' },
  { label: 'Telegram', text: 'Telegram', href: 'https://t.me/+XXZutZ23nsIxMTk1', icon: 'telegram' },
  {
    label: 'WhatsApp',
    text: 'WhatsApp',
    href: 'https://chat.whatsapp.com/IrXi3E2xRh1JSUYuncVwEM?mode=gi_t',
    icon: 'whatsapp',
  },
];
